import { render, staticRenderFns } from "./recipeSummary.vue?vue&type=template&id=77b2e01b"
import script from "./recipeSummary.vue?vue&type=script&lang=js"
export * from "./recipeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports